import {
  EnvironmentProviders,
  inject,
  provideEnvironmentInitializer,
  Provider,
} from '@angular/core';
import {
  provideSoftAppsModule,
  withLazySoftAppsModuleTranslation,
  withSoftAppsModuleRoutes,
} from '@softapps/core';
import { default as deTitles } from '../i18n/de.titles.json';
import {
  ApplicationStore,
  getModuleGroupByName,
  SOFTLINE_FEATURE_APPLICATIONS,
} from '@softline/application';
import { Store } from '@softline/core';
import { SOFTLINE_FEATURE_TRANSLATION, TranslationStore } from '@softline/ui-core';
import { default as de } from '../i18n/de.json';
import { wiegungRoutes } from './wiegung.routes';

export function provideWiegungModule() {
  return [
    ...provideSoftAppsModule(
      {
        name: 'wiegung',
        title: 'Wiegung',
        icon: 'fa-regular fa-scale-balanced',
        route: '/wiegung',
        group: getModuleGroupByName('Schmuck'),
      },
      withSoftAppsModuleRoutes({ app: wiegungRoutes }),
      withLazySoftAppsModuleTranslation({
        eager: { de: deTitles },
        lazy: { de: () => import('../i18n/de.json') },
      })
    ),
  ];
}

export const wiegungProviders: (Provider | EnvironmentProviders)[] = [
  provideEnvironmentInitializer(async () => {
    const store = inject(Store);

    store.commit(SOFTLINE_FEATURE_TRANSLATION, TranslationStore.mutations.add, {
      module: 'wiegung',
      language: 'de',
      translations: de,
    });

    store.commit(SOFTLINE_FEATURE_APPLICATIONS, ApplicationStore.mutations.add, {
      name: 'Wiegung',
      route: '/wiegung',
      icon: 'fa-regular fa-scale-balanced',
      //permission: SOFTLINE_PERMISSION_GOLDSCHMIEDE,
      group: getModuleGroupByName('Schmuck'),
    });
  }),
];
